import Icon from '../../../components/AppIcon';

const StatsCard = ({ icon, label, value, trend, trendValue, color = 'primary' }) => {
  return (
    <div className="bg-card rounded-lg md:rounded-xl p-2.5 md:p-5 shadow-md hover:shadow-lg transition-smooth border border-border">
      <div className="flex items-start justify-between mb-1.5 md:mb-3">
        <div className={`w-7 h-7 md:w-10 md:h-10 rounded-md md:rounded-lg bg-${color}/10 flex items-center justify-center`}>
          <Icon name={icon} size={14} className={`md:w-[18px] md:h-[18px] text-${color}`} />
        </div>
        {trend && (
          <div className={`flex items-center gap-0.5 md:gap-1 px-1.5 py-0.5 md:px-2 md:py-1 rounded-full text-[10px] md:text-xs font-medium ${
            trend === 'up' ? 'bg-success/10 text-success' : 'bg-destructive/10 text-destructive'
          }`}>
            <Icon name={trend === 'up' ? 'TrendingUp' : 'TrendingDown'} size={10} className="md:w-3 md:h-3" />
            <span>{trendValue}</span>
          </div>
        )}
      </div>
      <div>
        <p className="text-[10px] md:text-sm text-muted-foreground mb-0.5 md:mb-1">{label}</p>
        <p className="text-base md:text-2xl font-bold text-foreground">{value}</p>
      </div>
    </div>
  );
};

export default StatsCard;